import React, { FC, useEffect } from 'react';

import { Box, Heading } from '@rover/kibble/core';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';
import {
  EXPLANATION_MODAL_HEADER,
  EXPLANATION_MODAL_PARAGRAPH_WITH_LINK,
  URL,
} from '@rover/react-lib/src/pages/search/SearchPage/components/Modals/FeeExplanationModal/constants';
import { isMobileBrowser } from '@rover/rsdk/src/modules/Network/userAgent';
import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import emitMetric from '@rover/utilities/emitMetric';
import { getIsPriceTransparencyFull } from '@rover/utilities/priceTransparency';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  priceTransparencyLevel: PriceTransparencyLevel;
  bookingPercentageFee: string;
};
const FeeExplanationBottomSheet: FC<Props> = ({
  isOpen,
  onClose,
  priceTransparencyLevel,
  bookingPercentageFee,
}) => {
  const source = isMobileBrowser() ? 'mobile_web' : 'web';
  const isPtFull = getIsPriceTransparencyFull(priceTransparencyLevel);

  useEffect(() => {
    if (isOpen) {
      emitMetric('how-pricing-works-modal-viewed', { source });
    }
  }, [isOpen, source]);

  return (
    <BottomSheet
      height={520}
      isOpen={isOpen}
      onRequestClose={onClose}
      hideCloseIcon
      isDismissible
      closeOnDragDown
    >
      <Box>
        <Heading size="300" fontWeight="semibold">
          {EXPLANATION_MODAL_HEADER()}
        </Heading>
        <TextWithSingleInlineLink
          paragraphText={EXPLANATION_MODAL_PARAGRAPH_WITH_LINK(isPtFull, bookingPercentageFee)}
          href={URL()}
          target="_blank"
        />
      </Box>
    </BottomSheet>
  );
};

export default FeeExplanationBottomSheet;
